//funzione per creare il button che aprirà il drawer della toc
import React from 'react'
import {Component} from 'react'
import tocImage from './list_black.svg'
import Tooltip from '@material-ui/core/Tooltip';
// import './ButtonMenuToc.css'

export default class ButtonMenuToc extends Component {
    
constructor(props){
    super(props);
    this.state = {
        buttonStyle: props.button,

        isToggleOn: true
      }
          // This binding is necessary to make `this` work in the callback
        
          
          this.handleClick = this.handleClick.bind(this);

}

handleClick() {
    this.setState(function(prevState) {
        this.props.openMenu(true)
        return {isToggleOn: !prevState.isToggleOn};
    });
    
}

render() {   
    return (
        // <Slide direction="left" in={this.state.isToggleOn } >
        <Tooltip title="Tabella dei contenuti">
        <button  style={ this.state.buttonStyle} onClick={this.handleClick}>
            <img style={{width: '22px',height: '22px'}} src={tocImage} alt="trip"/>
        </button>
        </Tooltip>
        )
    }
}